<template>
    <div id="mapOverlay" ref="mapOverlay" :class="exhibition">
        <img class="atlas-logo" v-if="exhibition == ''" :src="assets + 'Logo_AV-Atlas.svg'" />
        <img class="atlas-logo" v-if="exhibition == 'beethoven'" :src="assets + 'Beethoven_logo.png'" />
        <img class="atlas-logo" v-if="exhibition == 'schoenberg'" :src="assets + 'Schoenberg_logo.png'" />
        <div class="controlContainer">
            <div class="map-search" ref="searchContainer">
                <input id="mapSearch" 
                       ref="searchInput"
                       class="collapsed" 
                       @input="$emit('emitMapSearch', ($event.target).value)" 
                       @focus="showSearchResults"
                       :placeholder="$t(exhibition + 'overlay.searchAtlas')">
                <img class="search-logo" 
                     @click="toggleSearchBar" 
                     :src="assets + 'search.svg'" />
            </div>
            <div class="control-section search-results">
                <SearchResults  @emitSelect="recieveSelect" />
            </div>
            <div class="control-section city-walks">
                <div class="control-heading collapsed" onclick="$('#mapSearch').addClass('collapsed');" data-bs-toggle="collapse" data-bs-target="#collapse-city-walks" aria-expanded="false" aria-controls="collapse-city-walks">
                    <img class="control-logo" :src="assets + 'Spazierende.svg'" /><span>{{ $t('overlay.cityWalks') }}</span>
                </div>
                <div class="control-body collapse" id="collapse-city-walks" data-bs-parent="#mapOverlay">
                    <a href="#" class="city-walk" v-for="item in cityWalks" @click="$emit('emitCityWalk', item); this.currentCityWalk = item;" onclick="$('.control-body').collapse('hide');">
                        <p class="walk-title">{{ item.title }}</p>
                        <p class="walk-infos"><span v-if="item.place">{{ item.place }}</span><span v-if="item.stops">{{ item.stops.length }} {{ $t('overlay.locations') }}</span><span v-if="item.mediaCount">{{ item.mediaCount }} {{ $t('overlay.media') }}</span><span v-if="item.distance">{{ item.distance }} km</span></p>
                    </a>
                </div>
            </div>
            <div class="control-section region-filter">
                <input id="regionFilter" :value="regionFilter" @input="$emit('emitRegionFilter', ($event.target).value)" type="hidden">
                <div class="control-heading collapsed" onclick="$('#mapSearch').addClass('collapsed');" data-bs-toggle="collapse" data-bs-target="#collapse-region-filter" aria-expanded="false" aria-controls="collapse-region-filter">
                    <img class="control-logo" :src="assets + 'map.svg'" /><span>{{ $t('overlay.filterRegion') }}</span>
                </div> 
                <div class="control-body collapse" id="collapse-region-filter" data-bs-parent="#mapOverlay">
                    <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'worldwide')">
                        {{ $t('overlay.worldwide') }}
                    </a>
                    <a href="#" class="region collapsed" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'austria')" data-bs-toggle="collapse" data-bs-target="#collapse-states" aria-expanded="false" aria-controls="collapse-states">
                        {{ $t('overlay.austria') }} <button class="region-collapse-toggle"></button>
                    </a>
                    <div class="states collapse" :class="{ show: exhibition == 'beethoven'}" id="collapse-states">
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-1')">
                            {{ $t('overlay.states.burgenland') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-2')">
                            {{ $t('overlay.states.carinthia') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-3')">
                            {{ $t('overlay.states.lowerAustria') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-4')">
                            {{ $t('overlay.states.upperAustria') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-5')">
                            {{ $t('overlay.states.salzburg') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-6')">
                            {{ $t('overlay.states.styria') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-7')">
                            {{ $t('overlay.states.tyrol') }}
                        </a>
                        <a href="#" class="region" v-if="exhibition != 'beethoven'" @click="$emit('emitRegionFilter', 'states-8')">
                            {{ $t('overlay.states.vorarlberg') }}
                        </a>
                        <a href="#" class="region collapsed" @click="$emit('emitRegionFilter', 'states-9')" data-bs-toggle="collapse" data-bs-target="#collapse-vienna" aria-expanded="false" aria-controls="collapse-vienna">
                            {{ $t('overlay.states.vienna') }} <button class="region-collapse-toggle"></button>
                        </a>
                        <div class="vienna collapse" id="collapse-vienna">
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1010')">1010 - Innere Stadt</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1020')">1020 - Leopoldstadt</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1030')">1030 - Landstraße</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1040')">1040 - Wieden</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1050')">1050 - Margareten</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1060')">1060 - Mariahilf</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1070')">1070 - Neubau</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1080')">1080 - Josefstadt</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1090')">1090 - Alsergrund</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1100')">1100 - Favoriten</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1110')">1110 - Simmering</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1120')">1120 - Meidling</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1130')">1130 - Hietzing</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1140')">1140 - Penzing</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1150')">1150 - Rudolfsheim-Fünfhaus</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1160')">1160 - Ottakring</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1170')">1170 - Hernals</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1180')">1180 - Währing</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1190')">1190 - Döbling</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1200')">1200 - Brigittenau</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1210')">1210 - Floridsdorf</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1220')">1220 - Donaustadt</a>
                            <a href="#" class="region" @click="$emit('emitRegionFilter', 'vienna-1230')">1230 - Liesing</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="control-section new-filter" v-if="newLocations && newLocations.length > 0">
                <div class="control-heading collapsed" onclick="$('#mapSearch').addClass('collapsed');" data-bs-toggle="collapse" data-bs-target="#collapse-new-filter" aria-expanded="false" aria-controls="collapse-new-filter">
                    <img class="control-logo" :src="assets + 'neu.svg'" /><span>{{ $t(exhibition + 'overlay.filterNew') }}</span>
                </div>
                <div class="control-body collapse" id="collapse-new-filter" data-bs-parent="#mapOverlay">
                    <a href="#" class="new-location" v-for="item in newLocations" @click="$emit('emitNewFilter', item.uniqueIdentifier)" data-bs-toggle="collapse" data-bs-target="#collapse-new-filter">
                        {{ item.title }}
                    </a>
                </div>
            </div>
            <div class="fold-in-map" onclick="$('.controlContainer').toggleClass('folded-in');">
                <img class="chevron-right" :src="assets + 'chevron-right.svg'" />
            </div>
        </div>
        <div class="cityWalkContainer folded-in" v-if="currentCityWalk">
            <div class="walk-title">
                <button class="btn-close" @click="$emit('emitCityWalk', null); currentCityWalk = null;"></button>
                <button class="btn-info" onclick="$('.cityWalkContainer').removeClass('folded-in');"></button>
                <p>{{ $t('overlay.cityWalk') }} {{  currentCityWalk.sorting }}: {{  currentCityWalk.title }}</p>
            </div>
            
            <div class="walk-infos">
                <button class="fold-in-walk" onclick="$('.cityWalkContainer').addClass('folded-in');"></button>
                <div class="walk-content">
                    <p class="walk-description" v-if="currentCityWalk.description">
                        {{  currentCityWalk.description }}
                    </p>
                    <a class="route-button" role="button" href="#" @click="$emit('emitStartCityWalk');" onclick="$('.cityWalkContainer').addClass('folded-in');"><span>{{$t("cityWalk.beginNavigation")}}</span></a>
                    <ol class="walk-stops">
                        <a href="#" v-for="(stop, index) in currentCityWalk.stops" @click="$emit('emitWalkStop', index)">
                            <li class="walk-stop">
                                {{ stop.title }}
                            </li>
                        </a>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchResults from './SearchResults.vue'

export default {
    name: "MapOverlay",
    components: {
        SearchResults
    },
    data() {
        var exhibition = "";
        var exhibitionCall = "";
        if(window.location.href.indexOf("beethoven") > -1){
            exhibition = "beethoven";
            exhibitionCall = '&tx_mbitatlas_getmarkers[exhibition]=beethoven';
        }
        if(window.location.href.indexOf("schoenberg") > -1){
            exhibition = "schoenberg";
            exhibitionCall = '&tx_mbitatlas_getmarkers[exhibition]=schoenberg';
        }

        return {
            assets: location.origin + '/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/',
            newLocations: null,
            cityWalks: null,
            currentCityWalk: null,
            exhibition: exhibition,
            exhibitionCall: exhibitionCall
        };
    },
    methods: {
        recieveSelect(item){
            this.$emit('emitSelectedSearchResult', item);
            // Hide search bar and results when a result is selected
            this.hideSearchBar();
        },
        
        toggleSearchBar() {
            const searchInput = this.$refs.searchInput;
            
            if (searchInput.classList.contains('collapsed')) {
                // Show search bar and focus it
                searchInput.classList.remove('collapsed');
                searchInput.focus();
            } else {
                // Hide search bar and results
                this.hideSearchBar();
            }
        },
        
        showSearchResults() {
            const searchInput = this.$refs.searchInput;
            
            // Always expand the search bar when focused
            searchInput.classList.remove('collapsed');
            
            // Check if we're on desktop (using window width as a proxy)
            const isDesktop = window.innerWidth > 991.98;
            
            if (isDesktop) {
                // Desktop behavior: show results if they exist (like the original onfocusin)
                const searchResultElements = this.$el.querySelectorAll('.search-result');
                if (searchResultElements && searchResultElements.length > 0) {
                    const searchResults = this.$el.querySelector('#collapse-search-results');
                    if (searchResults) {
                        searchResults.classList.add('show');
                    }
                }
            } else {
                // Mobile behavior: show results only if they exist and search bar has content
                const searchResultElements = this.$el.querySelectorAll('.search-result');
                const hasResults = searchResultElements && searchResultElements.length > 0;
                const hasSearchContent = searchInput.value && searchInput.value.trim().length > 0;
                
                if (hasResults && hasSearchContent) {
                    const searchResults = this.$el.querySelector('#collapse-search-results');
                    if (searchResults) {
                        searchResults.classList.add('show');
                    }
                }
            }
        },
        
        hideSearchBar() {
            const searchInput = this.$refs.searchInput;
            const searchResults = this.$el.querySelector('#collapse-search-results');
            
            searchInput.classList.add('collapsed');
            // Always hide search results when search bar collapses
            if (searchResults) {
                searchResults.classList.remove('show');
            }
        }
    },
    mounted() {
        fetch(this.$t("apiBase") + "?type=1740552151&tx_mbitatlas_getmarkers[getNew]=1" + this.exhibitionCall)
            .then((response) => response.json())
            .then((data) => {
                this.newLocations = data.response.docs;
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
        var searchExhibition = "";
        if(this.exhibition){
            searchExhibition = "&tx_mbitatlas_getcitywalks[exhibition]=" + this.exhibition;
        }
        fetch(this.$t("apiBase") + "?type=1740552153" + searchExhibition)
            .then((response) => response.json())
            .then((data) => {
                this.cityWalks = data.walks;
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }
};

</script>

<style scoped>
</style>